// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/unlike_generation.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionGenerationLike } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/unlike_generation.proto.
 */
export const file_vision_generations_v1_unlike_generation: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vZ2VuZXJhdGlvbnMvdjEvdW5saWtlX2dlbmVyYXRpb24ucHJvdG8SHHByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEiiAEKF1VubGlrZUdlbmVyYXRpb25SZXF1ZXN0EkwKBnBhcmFtcxgBIAEoCzI8LnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuVW5saWtlR2VuZXJhdGlvblJlcXVlc3QuUGFyYW1zGh8KBlBhcmFtcxIVCg1nZW5lcmF0aW9uX2lkGAEgASgJIrYBChhVbmxpa2VHZW5lcmF0aW9uUmVzcG9uc2USTQoGcmVzdWx0GAEgASgLMj0ucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5Vbmxpa2VHZW5lcmF0aW9uUmVzcG9uc2UuUmVzdWx0GksKBlJlc3VsdBJBCgVsaWtlcxgBIAMoCzIyLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuVmlzaW9uR2VuZXJhdGlvbkxpa2ViBnByb3RvMw", [file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.UnlikeGenerationRequest
 */
export type UnlikeGenerationRequest = Message<"protos.vision.generations.v1.UnlikeGenerationRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.UnlikeGenerationRequest.Params params = 1;
   */
  params?: UnlikeGenerationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.UnlikeGenerationRequest.
 * Use `create(UnlikeGenerationRequestSchema)` to create a new message.
 */
export const UnlikeGenerationRequestSchema: GenMessage<UnlikeGenerationRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_unlike_generation, 0);

/**
 * @generated from message protos.vision.generations.v1.UnlikeGenerationRequest.Params
 */
export type UnlikeGenerationRequest_Params = Message<"protos.vision.generations.v1.UnlikeGenerationRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.UnlikeGenerationRequest.Params.
 * Use `create(UnlikeGenerationRequest_ParamsSchema)` to create a new message.
 */
export const UnlikeGenerationRequest_ParamsSchema: GenMessage<UnlikeGenerationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_unlike_generation, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.UnlikeGenerationResponse
 */
export type UnlikeGenerationResponse = Message<"protos.vision.generations.v1.UnlikeGenerationResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.UnlikeGenerationResponse.Result result = 1;
   */
  result?: UnlikeGenerationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.UnlikeGenerationResponse.
 * Use `create(UnlikeGenerationResponseSchema)` to create a new message.
 */
export const UnlikeGenerationResponseSchema: GenMessage<UnlikeGenerationResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_unlike_generation, 1);

/**
 * @generated from message protos.vision.generations.v1.UnlikeGenerationResponse.Result
 */
export type UnlikeGenerationResponse_Result = Message<"protos.vision.generations.v1.UnlikeGenerationResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.VisionGenerationLike likes = 1;
   */
  likes: VisionGenerationLike[];
};

/**
 * Describes the message protos.vision.generations.v1.UnlikeGenerationResponse.Result.
 * Use `create(UnlikeGenerationResponse_ResultSchema)` to create a new message.
 */
export const UnlikeGenerationResponse_ResultSchema: GenMessage<UnlikeGenerationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_unlike_generation, 1, 0);

